<template>
  <div class="board">
    <div class="board-top">
      <div class="board-line"
        v-for="item in searchInputData"
        :key="item.data"
        :class="{
          'board-line--sort' : item.type === 'sort',
          'board-line--period' : item.type === 'period',
          'board-line--time' : item.type === 'time'
        }">
        <template v-if="item.type === 'select'">
          <el-select v-model="searchData[item.data]" size="mini" :placeholder="item.pla">
            <el-option v-for="obj in item.array" :key="obj.name" :value="obj.id" :label="obj.name">
              {{ obj.name }}
            </el-option>
          </el-select>
        </template>
        <template v-else-if="item.type === 'sort'">
          <el-select v-model="searchData.sort" size="mini" placeholder="ASIN">
            <el-option v-for="obj in item.array" :key="obj.name" :value="obj.id" :label="obj.name">
              {{ obj.name }}
            </el-option>
          </el-select>
          <el-input class="board-line--input" placeholder="请输入" v-model="searchData.text"></el-input>
        </template>
        <template v-else-if="item.type === 'period'">
          <div class="board-line__period"
            v-for="timeItem in item.array"
            :key="timeItem.id"
            :class="{'board-line__period--select': timeItem.id == searchData.timePeriod}"
            @click="periodItemClick(timeItem.id)">
            {{ timeItem.name }}
          </div>
        </template>
        <template v-else-if="item.type === 'time'">
          <el-date-picker
            type="daterange"
            v-model="searchData.time"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </template>
      </div>
      <div class="board-line__btn" @click="functionProcessing">查询</div>
    </div>
    <div class="board-center">
      <div class="board-center__module"
        v-for="item in summaryModule"
        :key="item.id"
        :class="{
          'board-center__module--sale': item.id === 'sale',
          'board-center__module--cost': item.id === 'cost',
        }">
        <div class="board-center__top">
          <div class="board-center__title">
            {{ item.name }}
            <span class="board-center__time" v-if="item.updataTime != null">
              更新时间:{{ item.updataTime == '' ? '--' : item.updataTime }}
            </span>
          </div>
          <div class="board-center__more" @click="functionProcessing">更多></div>
        </div>
        <div class="board-center-summary">
          <div class="board-center-summary__item"
            v-for="list in item.list"
            :key="list.id">
            <div class="board-center-summary__title">{{ list.name }}</div>
            <div class="board-center-summary__num"
              :style="{color: colorArray[Math.round(Math.random() * 5)]}">{{ list.num }}</div>
            <div class="board-center-summary__pre" v-if="list.previousNum != null">
              上期汇总&nbsp;{{ list.previousNum }}
            </div>
          </div>
        </div>
        <template v-if="item.type !== 'table'">
          <div class="board-center__echart" :id="item.type + item.id">echart</div>
        </template>
        <template v-else>
          <Table
            :head="item.tableHead"
            :width="item.tableWidth"
            line-height="30"
            :no-data-img-index="1"
            head-color="#F1F2F8"
            :no-data-prompt-text="noDataPromptText"></Table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { BoardSearchData, BoardInputNewModule, BoardSelectOption } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'summaryDashboard',
  components: {
    Table,
  },
  data(){
    return {
      /**搜索数据 */
      searchData: new BoardSearchData(),
      /**搜索输入框 */
      searchInputData: BoardInputNewModule.NEWSEARCHINPUT(),
      /**汇总数据图表 */
      summaryModule: BoardInputNewModule.NEWSUMMARYECHARTSARRAY(),
      colorArray: ['#7176bd', '#fec840', '#44c0d5', '#fec840', '#fec840', '#f38e8c'],
      /**无数据提示文字 */
      noDataPromptText: `
        <div style="color: #28b8d0; font-weight: bold">
          护航鲸未能查询到任何数据......
        </div>
        <div style="line-height: 20px">
          若您刚授权，请等待系统同步数据，需要几个小时;若您有数据却一直不显示，请联系客服！
        </div>
      `
    }
  },
  created(){
    this.searchInputData.country.array = this.searchInputData.country.array.map((s, i) => {
      return new BoardSelectOption(s, i)
    })
    this.searchInputData.timePeriod.array = BoardInputNewModule.NEWTIMEPERIODARRAY()
  },
  mounted(){
    this.drawEcharts()
  },
  methods: {
    /**时间周期点击事件 */
    periodItemClick(id){
      this.searchData.timePeriod = id
    },
    /**功能处理中 */
    functionProcessing(){
      this.$message.warning("功能处理中");
    },
    /**绘制图表 */
    drawEcharts(){
      let report = this.summaryModule.report
      let cost = this.summaryModule.cost
      let line = this.$echarts.init(document.getElementById(report.type + report.id))
      let pie = this.$echarts.init(document.getElementById(cost.type + cost.id))
      line.setOption(report.echartOption)
      pie.setOption(cost.echartOption)
    }
  }
}
</script>

<style lang="scss" scoped>
.board{
  width: 1810px;
  &-top{
    display: flex;
  }
  &-line{
    margin: 0 5px;
    ::v-deep{
      .el-input__inner{
        border-radius: 0;
        width: 140px;
        height: 30px;
      }
    }
    &--sort{
      display: flex;
      ::v-deep{
        .el-input__inner{
          width: 90px;
        }
      }
    }
    &--input{
      ::v-deep{
        .el-input__inner{
          width: 150px;
        }
      }
    }
    &--period{
      display: flex;
    }
    &--time{
      height: 30px;
      ::v-deep{
        .el-input__inner{
          width: 250px;
        }
        .el-range-separator{
          transform: translateY(-5px);
        }
        .el-date-editor .el-range__icon{
          transform: translateY(-5px);
        }
      }
    }
    &__period{
      width: 80px;
      border: 1px solid #DCDFE6;
      height: 30px;
      line-height: 30px;
      text-align: center;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
      &--select{
        background: #fca605;
        color: white;
        border: none;
        &:hover{
          cursor: default;
          opacity: 1;
        }
      }
    }
    &__btn{
      height: 30px;
      line-height: 30px;
      background: #00a0c7;
      padding: 0 20px;
      color: white;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
  &-center{
    display: flex;
    flex-wrap: wrap;
    &__module{
      width: 875px;
      height: 400px;
      background: #ffffff;
      padding: 10px 5px;
      margin: 10px 5px;
      box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
      box-sizing: content-box;
      &--sale{
        width: 400px;
      }
      &--cost{
        width: 455px;
      }
    }
    &__top{
      display: flex;
      justify-content: space-between;
      margin: 5px 10px;
    }
    &__title{
      color: #38616c;
      font-weight: bold;
    }
    &__time{
      color: #a8a8a8;
      font-weight: lighter;
      margin: 0 5px;
    }
    &__more{
      color: #a8a8a8;
      font-size: 12px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &-summary{
      display: flex;
      &__item{
        width: 146px;
        margin: 5px 10px;
        border-right: 1px solid black;
        &:last-child{
          border: none;
        }
      }
      &__num{
        padding: 8px 0;
        font-size: 18px;
        font-weight: bold;
      }
    }
    &__echart{
      height: 300px;
    }
  }
}
</style>
